// Import Dependencies
import React from 'react';

// Import custom components
import LoginBox from '../../../reusables/login';

// Import helper functions
import { checkTokenIfLoggedIn } from '../../../../helper';


class MemberLoginPage extends React.Component {
    componentDidMount = () => {
        // Check cookie if member is already logged in.
        checkTokenIfLoggedIn();
    }

    render() {
        return (
            <div>
                <LoginBox type='member' />
            </div>
        )
    }

}

export default MemberLoginPage;